import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthenticationService } from '../services/authentication.service';

@Injectable({
  providedIn: 'root',
})
export class LoginGuard {
  constructor(
    private router: Router,
    private authService: AuthenticationService,
  ) {}

  canActivate(
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | boolean | UrlTree {
    if (!this.authService.hasLocalSessionHint()) {
      this.storeRedirect(state.url);
      return this.router.createUrlTree(['/login']);
    }

    // Valida cookie refresh antes de mostrar la app (evita UI "logueada" fantasma)
    return this.authService.ensureSession().pipe(
      map(() => true),
      catchError(() => {
        this.authService.clearLocalSession();
        this.storeRedirect(state.url);
        return of(this.router.createUrlTree(['/login']));
      }),
    );
  }

  private storeRedirect(url: string): void {
    if (url && url !== '/' && !url.startsWith('/login')) {
      sessionStorage.setItem('redirectAfterLogin', url);
    }
  }
}
